<ng-container>
    <div [hidden]="viewState === viewStates.confirm">
        <h1 mat-dialog-title>Delete {{ form?.commonDocument ? 'Common' : 'F&I' }} Form</h1>

        <div>
            <p>
                Are you sure you want to delete <strong>{{ form.DdjTemplate.displayName }}</strong
                >?
            </p>
            <p>
                Note: Deleting an {{ form?.commonDocument ? 'Common' : 'F&I' }} form does not remove it from any existing Deal Jackets; it only disables it from
                being used in future Deal Jackets.
            </p>
        </div>

        <div style="display: flex; justify-content: flex-end; align-items: center" class="form-footer">
            <section>
                <div class="cancel-button-row">
                    <div class="confirm-actions right-align" mat-dialog-actions>
                        <button style="color: var(--tenant-header)" mat-button class="secondary" (click)="cancel()">Cancel</button>
                        <button mat-button class="primary" (click)="this.form.commonDocument ? deleteCommonTemplate() : deleteTemplate()" type="submit">
                            Delete
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</ng-container>

<ng-container>
    <div [hidden]="viewState === viewStates.success">
        <div mat-dialog-content>
            <h1>{{ form?.commonDocument ? 'Common' : 'F&I' }} Form Deleted</h1>
            <p>
                <strong>{{ form.DdjTemplate.displayName }}</strong> has been deleted successfully.
            </p>
        </div>
        <div class="form-footer">
            <section>
                <div style="display: flex; justify-content: flex-end; align-items: center" class="cancel-button-row">
                    <button mat-button class="primary" (click)="close()">OK</button>
                </div>
            </section>
        </div>
    </div>
</ng-container>
